import React from 'react';
import { getInitial } from '../avatarColor';
import { agentColor } from './AgentChip';

// The agent's picture, or a deterministic coloured swatch with its initials.
// Moved out of Admin/workspaceSettingsShared (WEB-9178) once the routine rows
// and the agent page needed it too — an avatar isn't a settings concern.

const AgentAvatar = ({
	agent,
	size = 24,
	style
}: {
	agent: { agentId?: number; id?: number; name: string; avatarUrl?: string | null };
	size?: number;
	style?: React.CSSProperties;
}) => {
	const url = agent.avatarUrl;
	if (url) {
		return (
			<img
				src={url}
				alt=""
				style={{ width: size, height: size, borderRadius: 4, objectFit: 'cover', ...style }}
			/>
		);
	}
	const id = agent.agentId ?? agent.id ?? 0;
	return (
		<div
			className="ws-agent-swatch"
			style={{
				background: agentColor(id),
				width: size,
				height: size,
				fontSize: Math.round(size * 0.42),
				...style
			}}
		>
			{getInitial(agent.name)}
		</div>
	);
};

export default AgentAvatar;
